/**
 * Shared Reset Button Component
 * 
 * Standardized reset button used across all tool features to provide
 * consistent look, behavior, and conditional rendering logic.
 */

import React from 'react'
import Button from './Button'

interface ResetButtonProps {
  /** Whether to show the reset button (conditional rendering) */
  isVisible: boolean
  /** Function to call when reset button is clicked */
  onReset: () => void
  /** Additional CSS classes (optional) */
  className?: string
  /** Whether the button should be disabled */
  disabled?: boolean
}

const ResetButton: React.FC<ResetButtonProps> = ({
  isVisible,
  onReset,
  className = '',
  disabled = false
}) => {
  if (!isVisible) {
    return null
  }

  return (
    <div className="flex-shrink-0 w-full sm:w-auto mt-2 sm:mt-0">
      <Button
        type="button"
        onClick={onReset}
        variant="primary"
        disabled={disabled}
        className={`w-full sm:w-auto hover:bg-white hover:text-riddell-red px-3 sm:px-4 py-2 text-sm sm:text-base font-bold uppercase tracking-wide flex items-center justify-center space-x-2 transition-all duration-150 ${className}`}
      >
        <svg 
          className="w-3 h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24" 
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" 
          />
        </svg>
        <span>RESET</span>
      </Button>
    </div>
  )
}

export default ResetButton
